import { PaymentsListView, } from "./PaymentsListView.tsx";

export function PaymentsListModerator() {
  return (
    <PaymentsListView
      isLoading={false}
      isSuccess={true}
      data={[]}
    />
  );
}
